module.exports = __webpack_public_path__ + "img/KSC06842.51bcee1e.jpg";